// extracted by mini-css-extract-plugin
export default {"description":"style_description__+Xzht","fade-in":"style_fade-in__AHeth","top":"style_top__nOxkt","image":"style_image__KM-av"};